import React, { useState } from 'react'
import axios from 'axios';
import '../Login/Login.css'
import './OlvContraseña.css'
import { useNavigate, Link } from 'react-router-dom'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentOlvContraseña } from '../../components/Contraseñas/ContentOlvContraseña'
import { IntroducirCodigoConfirmacion } from '../../components/Contraseñas/IntroducirCodigoConfirmacion'
import { CambiarContraseña } from '../../components/Contraseñas/CambiarContraseña'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Modal as M} from 'react-bootstrap'
import HeaderHome from '../../components/headerHome/HeaderHome';

export const OlvContraseña = () => {
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext);
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false);
    }
  }
  const navigate = useNavigate();
  const olvidarContraseña = () => {
    navigate('/recuperarContraseña');
  }

  const [estadoRecuperarContraseña, setEstadoRecuperarContraseña] = useState(0);

  const [codigoConfirmacion, setCodigoConfirmacion] = useState('');

  const [codigo, setCodigo] = useState('');

  const [guardarCorreo, setGuardarCorreo] = useState('');

  const [idUsuarioRestablecerContrasena, setIdUsuarioReestablecerContrasena] = useState('');

  const [modalContrasena, setModalContrasena] = useState(false)

  const [confirmacionContraseña, setConfirmacionContraseña] = useState(true);

  const cambioContraseña = (constrasena) => {
    if ( constrasena.contrasena === '' ||  constrasena.confirmarContrasena=== '' ) {
      setConfirmacionContraseña(false);
    }else{
      if ( constrasena.contrasena.toString() === constrasena.confirmarContrasena.toString() ) {
        axios({
          method: 'put',
          url: window.ipdirection + 'reestablecerContrasena/'+ idUsuarioRestablecerContrasena + '/',
          data: {
            email: guardarCorreo,
            password: constrasena,
          },
        }).then((response) =>{
          setConfirmacionContraseña(true);
          setModalContrasena(true);
        })
      }else{
        setConfirmacionContraseña(false);
      }
    }
  }

  const comprobarCodigo = () => {
    (codigoConfirmacion === codigo)
      ? setEstadoRecuperarContraseña(3)
      : setEstadoRecuperarContraseña(4)
  }

  const goToLogin = () => {
    if(modalContrasena){
      setModalContrasena(false)
    }
    navigate('/login');
  }

  const consultarCorreo = (correo) => {
    setGuardarCorreo(correo)
    axios({
			method: 'get',
			url: window.ipdirection + 'comprobarUsuarioRegistrado/',
			params: {
				email: correo,
			},
		}).then((response)=>{
      setIdUsuarioReestablecerContrasena(response.data['usuario'])
      setCodigo(response.data['codigo'])
      setEstadoRecuperarContraseña(1)
    }).catch((error)=>{
      setEstadoRecuperarContraseña(2)
    })
  }

  const enviarCorreoCodigo = (correo) => {
    (consultarCorreo(correo))
      ? setEstadoRecuperarContraseña(1)
      : setEstadoRecuperarContraseña(2);
  }


  return (
    <>
    <div className='OlvContraseña' onClick={closeMenu}>
      <div className='headerOlvContraseña'> <HeaderHome /> </div>
      <div className='bodyOlvContraseña'>
        <div className='contentBodyOlvContraseña'>
          {
            (estadoRecuperarContraseña === 0 || estadoRecuperarContraseña === 2)
              ? <ContentOlvContraseña
                goToLogin={goToLogin}
                enviarCorreoCodigo={enviarCorreoCodigo}
                estadoRecuperarContraseña={estadoRecuperarContraseña}
                consultarCorreo={consultarCorreo}
              />
              : (estadoRecuperarContraseña === 1 || estadoRecuperarContraseña === 4)
                ? <IntroducirCodigoConfirmacion
                  codigoConfirmacion={codigoConfirmacion}
                  setCodigoConfirmacion={setCodigoConfirmacion}
                  estadoRecuperarContraseña={estadoRecuperarContraseña}
                  comprobarCodigo={comprobarCodigo}
                />
                : (estadoRecuperarContraseña === 3) &&
                  <CambiarContraseña
                    cambioContraseña={cambioContraseña}
                    confirmacionContraseña={confirmacionContraseña}
                  />
          }
        </div>
        <div className='footerOlvContraseña'> <MiFooter /> </div>
      </div>
    </div>
    <M
						centered={true}
						show={modalContrasena}
					>
						<M.Header>
							<div className='titulo-modal'>Contraseña reestablecida</div>
						</M.Header>
						<M.Body>
							<div className='descripcion-servicio descripcion-modal'>
                Nos complace informarte que tu solicitud de restablecimiento de contraseña se ha procesado con éxito. 
                A partir de ahora, podrás acceder a tu cuenta utilizando tu nueva contraseña.
							</div>
						</M.Body>
						<M.Footer>
							<div className='centrador'>
								<button
									className='btn login-boton'
									onClick={() => goToLogin()}
								>
									<b>Aceptar</b>
								</button>
							</div>
						</M.Footer>
					</M>
    </>
  )
}
